export default "__VITE_ASSET__DCJVC1HO__"